import { render, staticRenderFns } from "./LeccionC2.vue?vue&type=template&id=ee848f7e&"
import script from "./LeccionC2.vue?vue&type=script&lang=js&"
export * from "./LeccionC2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports